import React, { Component } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

const jackpotList = [
  {
    title: "jackpot",
    href: "",
    img: "/build/web/igame-index-lobby-wm/img/jackpot.jpg",
  }, {
    title: "jackpot",
    href: "",
    img: "https://s3.newworld.center/image/0f659bc5-c274-48d1-9afa-743a88a88be0.webp",
  },
   {
    title: "jackpot",
    href: "",
    img: "https://s3.newworld.center/image/4c2c5cb2-8e22-4d92-ac7c-86ca474a4254.webp",
  },
  ,
   {
    title: "jackpot",
    href: "",
    img: "https://s3.newworld.center/image/0eb5f05f-458e-41b6-af17-d78698ff4f23.webp",
  },
  ,
   {
    title: "jackpot",
    href: "",
    img: "https://s3.newworld.center/image/53360745-5aac-4004-a88d-86c302ea5303.webp",
  },
  ,
   {
    title: "jackpot",
    href: "",
    img: "https://s3.newworld.center/image/0df469c9-a42b-4a36-9e20-e8811ef5cb3c.webp",
  },

];

const settings = {
  dots: true,
  infinite: true,
  slidesToShow: 3, // 👈 เหมือน owl (ประมาณ 3 ช่อง)
  slidesToScroll: 1,
  autoplay: true,
  speed: 500,
  autoplaySpeed: 3000,
  arrows: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: { slidesToShow: 2 },
    },
    {
      breakpoint: 768,
      settings: { slidesToShow: 1 },
    },
  ],
};

class JackpotSlider extends Component {
  render() {
    return (
      <div className="jackpot-slider-wrap">
        <Slider {...settings}>
          {jackpotList.map((item, index) => (
            <div key={index} className="jackpot-item">
              <a href={item.href} title={item.title}>
                <img
                  className="thaitheme_pc"
                  src={item.img}
                  alt={item.title}
                />
              </a>
            </div>
          ))}
        </Slider>

        <style>{`
          .jackpot-slider-wrap {
            width: 100%;
            padding: 10px 0;
          }

          .jackpot-item {
            padding: 0 5px;
          }

          .jackpot-item img {
            width: 100%;
            display: block;
            border-radius: 6px;
          }

          .slick-list {
            margin: 0 -5px;
          }

          .slick-prev {
            left: 0;
            z-index: 10;
          }

          .slick-next {
            right: 0;
            z-index: 10;
          }

          .slick-prev:before,
          .slick-next:before {
            font-size: 24px;
          }
        `}</style>
      </div>
    );
  }
}

export default JackpotSlider;